import "./policy.css";

const Cookie = () => {
  return (
    <div className="policy cookie container">
      <h1>Cookies Policy</h1>
      <p>
        At Rexla Global, we use cookies to improve your experience on our
        website and ensure it works efficiently. By using our website, you agree
        to the use of cookies as described in this policy. You also have the
        option to manage or opt-out of certain cookies if you prefer.
      </p>

      <h4>What Are Cookies?</h4>
      <p>
        Cookies are small text files stored on your device (like your computer
        or smartphone) when you visit our website. They help us remember your
        actions and preferences over time, making your browsing experience
        easier and more personalized.
      </p>

      <h4>How We Use Cookies</h4>
      <h5>We use cookies for several purposes, including:</h5>
      <h6>1. Website Functionality:</h6>
      <p>
        Cookies help our website function properly. For example, they allow us
        to remember your login information, language preferences, or items in
        your cart, so you don’t have to re-enter this information each time you
        visit.
      </p>
      <h6>2. Improving User Experience:</h6>
      <p>
        Cookies help us analyze how you use the website, such as which pages you
        visit and how long you stay. This allows us to improve the website’s
        performance, ensuring it is user-friendly and meets your needs.
      </p>
      <h6>3. Personalized Content:</h6>
      <p>
        Cookies help us offer content tailored to your interests. This could
        include showing relevant products or features based on your previous
        visits, improving your experience by presenting information you’re most
        likely to engage with.
      </p>
      <h6>4. Marketing and Advertising:</h6>
      <p>
        Cookies help us display advertisements that are relevant to you. This
        includes personalized ads both on our website and across other websites
        you visit, based on your browsing behavior. This ensures we only show
        you ads that matter to you.
      </p>
      <h5>Types of Cookies We Use</h5>
      <h6>1. Essential Cookies:</h6>
      <p>
        These are necessary for the basic functionality of the website, such as
        logging in and securely processing your data. Without these cookies, you
        may not be able to use all the features of our site.
      </p>
      <h6>2. Performance and Analytics Cookies:</h6>
      <p>
        These cookies collect information about how users interact with our
        website. This helps us analyze traffic, improve website functionality,
        and make your experience more seamless. These cookies gather anonymous
        data, such as the pages you visit and any errors that might occur.
      </p>
      <h6>3. Functional Cookies:</h6>
      <p>
        These cookies allow us to remember choices you’ve made (like language or
        region) to provide enhanced, personalized features. They help us
        customize your experience and remember your preferences between visits.
      </p>
      <h6>4. Advertising and Marketing Cookies:</h6>
      <p>
        These cookies track your browsing habits and allow us to display
        advertisements that are relevant to your interests. They are often used
        by third-party advertisers to track your activity across multiple
        websites.
      </p>

      <h5>Managing and Opting Out of Cookies</h5>
      <p>
        You have control over the cookies that are placed on your device. Most
        browsers allow you to manage cookie settings, including blocking,
        deleting, or opting out of cookies. However, if you block or delete
        cookies, certain parts of the website may not work properly, and you may
        not be able to enjoy the full features of our website.
      </p>

      <h5>How to Opt-Out of Cookies:</h5>
      <h6> 1. Browser Settings:</h6>
      <p>
        You can configure your browser to accept or reject cookies. Most
        browsers give you the option to block cookies or delete them once
        they’ve been stored.
        <ul>
          <li>
            Google Chrome: Go to settings &gt; Privacy and security &gt; Cookies
            and other site data
          </li>
          <li>
            Mozilla Firefox: Go to options &gt; Privacy & Security &gt; Cookies
            and Site Data
          </li>
          <li>
            Safari: Go to preferences &gt; Privacy &gt; Cookies and website data
          </li>
        </ul>
      </p>
      <h6> 2. Third-Party Cookies:</h6>
      <p>
        For more control over third-party cookies used for advertising and
        tracking, you can visit the Network Advertising Initiative (NAI) or
        Digital Advertising Alliance (DAA) websites, which allow you to opt-out
        of targeted advertising cookies.
      </p>
      <h6> 3. Opt-Out Tools:</h6>
      <p>
        Some third-party services that we work with may also provide opt-out
        options directly on their sites, allowing you to stop receiving
        personalized ads based on your browsing behavior. You can visit the
        privacy settings of these services for more information.
      </p>

      <h4>Third-Party Cookies</h4>
      <p>
        We may allow third-party service providers, such as advertisers or
        analytics services, to use cookies on our website. These third parties
        may collect information about your activity across different websites to
        offer you targeted ads or measure website performance. Please note that
        we do not have control over these cookies.
      </p>

      <h4>Changes to This Cookies Policy</h4>
      <p>
        We may update this Cookies Policy from time to time. Any changes will be
        posted on this page, and the updated policy will be effective as soon as
        it is published. We encourage you to check this page periodically for
        any updates.
      </p>

      <h4>Questions?</h4>
      <p>
        If you have any further questions about how we use cookies or need help
        managing your cookie preferences, please contact us via our Support Page
        or consult Rexla Guide for further assistance.
      </p>

      <h4>Key Points:</h4>
      <ul>
        <li>
          Opting Out: Provides users the option to block or delete cookies using
          browser settings and external tools.
        </li>
        <li>
          Cookie Control: Gives users clear instructions on managing cookies and
          opting out of third-party cookies.
        </li>
        <li>
          Transparency: Clear information about the types of cookies used and
          why.
        </li>
      </ul>
    </div>
  );
};
export default Cookie;
